import { Routes } from '@angular/router';
import { AppInitializationGuard, WidgetsComponent } from '@evorait/pace-core';
import { DocboxComponent, PaceForms2Guard } from '@evorait/pace-forms';
import { ConfirmationCanDeactivateGuard } from './confirmation/confirmation.can-deactivate.guard';
import { ConfirmationComponent } from './confirmation/confirmation/confirmation.component';
import { ConfirmationResolver } from './confirmation/confirmation/confirmation.resolver';
import { MainComponent } from './core/components/main/main.component';
import { NotificationResolver } from './core/resolvers/notification.resolver';
import { DashboardComponent } from './dashboard/components/dashboard/dashboard.component';
import { OverviewComponent } from './details/overview/overview.component';
import { Forms2WrapperComponent } from './pace-forms-2-wrapper/components/forms2-wrapper/forms2-wrapper.component';
import { TimesheetAndExpensesComponent } from './timesheet/components/timesheet-and-expenses/timesheet-and-expenses.component';
import { TimesheetResolver } from './timesheet/components/timesheet-and-expenses/timesheet.resolver';
import { TimesheetCanDeactivateGuard } from './timesheet/timesheet.can-deactivate.guard';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { AuthGuard } from '@auth0/auth0-angular';

const authGuards = [];
if (environment.useMsal) {
    authGuards.push(MsalGuard);
}
if (environment.auth0?.clientId) {
    authGuards.push(AuthGuard);
}

export const routes: Routes = [
    { path: '', redirectTo: 'main/dashboard', pathMatch: 'full', canActivate: [...authGuards] },
    {
        path: 'main',
        component: MainComponent,
        canActivate: [AppInitializationGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                component: DashboardComponent,
            },
            {
                path: 'details/:frontid/:qmnum/:manum',
                component: OverviewComponent,
                resolve: { notification: NotificationResolver },
                runGuardsAndResolvers: 'always',
            },
            {
                path: 'confirmation/:frontid/:qmnum/:manum/:crmtype',
                component: ConfirmationComponent,
                canDeactivate: [ConfirmationCanDeactivateGuard],
                resolve: { confirmation: ConfirmationResolver, notification: NotificationResolver },
            },
            {
                path: 'forms2/:frontid/:qmnum/:manum/:materialid/:equipmentid/:formid/:language/:lockmode',
                component: Forms2WrapperComponent,
                canActivate: [PaceForms2Guard],
                canDeactivate: [PaceForms2Guard],
            },
            {
                path: 'timesheet',
                component: TimesheetAndExpensesComponent,
                canDeactivate: [TimesheetCanDeactivateGuard],
            },
            {
                path: 'timesheet/:date',
                component: TimesheetAndExpensesComponent,
                resolve: { date: TimesheetResolver },
                canDeactivate: [TimesheetCanDeactivateGuard],
            },
            {
                path: 'widgets',
                component: WidgetsComponent,
            },
            {
                path: 'docbox/:frontid/:qmnum/:manum',
                component: DocboxComponent,
            },
        ],
    },
    { path: '**', redirectTo: 'main/dashboard' },
];
